import {$} from '../jquery-definition.js';
import {CountUp} from 'countup.js';

$( function() {
	countUp();
} );

$( window ).scroll( function() {
	setTimeout( function() {
		countUp();
	}, 100 );
} );

function countUp() {
	$( '.block-count' ).each( function() {
		var $this = $( this );

		var count;
		var value = $this.attr( 'data-end-value' );
		var start = $this.attr( 'data-start-value' );
		var prefix = $this.attr( 'data-prefix' );
		var suffix = $this.attr( 'data-suffix' );
		var separator = $this.attr( 'data-separator' );
		var countOptions = {
			separator: separator,
			decimal: ',',
			duration: 2,
			startVal: start,
			prefix: prefix,
			suffix: suffix
		};

		if ( $this.is( ':in-viewport' ) ) {
			if ( !$this.hasClass( 'counted' ) ) {


				if ( $this.hasClass( 'count-integer' ) ) {
					count = new CountUp( $this[ 0 ], parseInt( value ), countOptions );
				} else if ( $this.hasClass( 'count-float' ) ) {
					countOptions.decimalPlaces = parseInt( $this.attr( 'data-decimal-places' ) );
					count = new CountUp( $this[ 0 ], parseFloat( value ), countOptions );
				}

				if ( !count.error ) {
					count.start();
				} else {
					console.error( count.error );
				}
			}

			$this.addClass( 'counted' );
		}
	} );
}
